import { render, staticRenderFns } from "./issueWriteButton.vue?vue&type=template&id=c6049424&scoped=true&"
import script from "./issueWriteButton.vue?vue&type=script&lang=ts&"
export * from "./issueWriteButton.vue?vue&type=script&lang=ts&"
import style0 from "./issueWriteButton.vue?vue&type=style&index=0&id=c6049424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6049424",
  null
  
)

export default component.exports